define('validation--match-pair',["exports"], function (exports) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    exports.default = function () {
        var questions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var answers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        return Array.isArray(questions) && questions.length && questions.length === questions.filter(function (o) {
            // clickable
            var node = document.getElementById(o.id);
            return node && node.dataset && node.dataset.id;
        }).length ? true : Array.isArray(answers) && answers.length && answers.length === answers.reduce(function (res, o) {
            // draggable
            return res + document.querySelectorAll("[id=\"" + o.id + "\"] .js-drag-item").length;
        }, 0) ? true : false;
    };
});
